<template>
    <div class="base-trumpet-add" :class="{'tradd-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">增加小号</div>
            </div>
            <div class="content-auto">
                <input class="value" type="text" maxlength="24" placeholder="请输入小号名（不得大于24个字符）" v-model="name" />
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
        <div class="btn" @click="addTrumpet">确认增加</div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseTrumpetAdd',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                name: '',
                loginData: {},
                userData: {}
            }
        },
        methods: {
            // 添加小号
            addTrumpet () {
                if (this.name.replace(/\s*/g, "")) {
                    let options = {
                        uid: this.userData.data.uid,
                        nick_name: this.name,
                        appid: this.loginData.appid, //渠道ID
                        system: this.config.system, //系统
                        machine_code: this.loginData.machine_code //设备号
                    }
                    options.sign = this.util.getSign(options, this.loginData.appkey)
                    this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=user&a=add_appuid', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            this.msg = '添加成功'
                            setTimeout(() => {
                                this.msg = null
                                this.$router.back()
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                }
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
            this.userData =JSON.parse(sessionStorage.getItem('userData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-trumpet-add {
        width: 864px;
        min-height: 888px;
        overflow: hidden;
        padding-bottom: 60px;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
            }
            .content-auto {
                padding: 0 60px;
                overflow: hidden;
                .value {
                    width: 100%;
                    height: 120px;
                    color: #fff;
                    font-size: 39px;
                    border: 0;
                    border-radius: 18px;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    margin: 60px 0 30px;
                    outline: none;
                }
                input::-webkit-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-moz-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-ms-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-o-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .tradd-sp {
        width: 1570px;
        min-height: 1614px;
        padding-bottom: 90px;
        border-radius: 32px;
        .content {
            .header {
                height: 240px;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .value {
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                    padding: 0 81px;
                    margin: 90px 0 54px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px;
        }
    }
</style>